import React from 'react';
import { Link } from 'react-router-dom';
import { Globe, Wrench, Users, Monitor, MapPin } from 'lucide-react';
import './Tentang.css';
import './Tentang-additional.css';
import { getOperatingMonths } from './utils/dateHelper';

function Tentang() {
  const operatingMonths = getOperatingMonths();
  const teamMembers = [
    {
      name: 'Yudha Cahyo Saputro',
      role: 'Founder & Digital Strategist',
      bio: 'Founder dengan pengalaman 1+ tahun dalam pengembangan website dan solusi digital untuk UMKM. Fokus pada memberikan solusi yang efektif, terukur, dan berorientasi pada pertumbuhan bisnis klien.',
      expertise: ['Website Development', 'SEO Optimization','Aplication Development'],
      image: `${process.env.PUBLIC_URL}/cakra_digital_innovation.png`,
      stats: {
        years: '1+',
        satisfaction: '100%',
        services: '3'
      }
    },
    {
      name: 'Bagas',
      role: 'co-founder & Digital Marketing Specialist',
      bio: 'Rekan kerja dengan pengalaman 5+ tahun di bidang digital marketing. Ahli senior dalam strategi pemasaran digital, campaign management, dan optimasi konversi untuk membantu klien mencapai target bisnis mereka.',
      expertise: ['Digital Marketing', 'Campaign Management', 'Social Media Strategy', 'SEO Marketing'],
      image: `${process.env.PUBLIC_URL}/cakra_digital_innovation.png`,
      stats: {
        years: '5+',
        satisfaction: '100%',
        services: '4'
      }
    }
  ];

  const commitments = [
    {
      title: 'Website Profesional untuk Bisnis',
      description: 'Membangun website modern, responsif, dan profesional yang dirancang khusus untuk kebutuhan bisnis UMKM, restoran, dan cafe.',
      icon: <Monitor size={32} />,
      specialTitle: true
    },
    {
      title: 'Optimasi Google & Google Maps',
      description: 'Membantu bisnis muncul di pencarian Google dan Google Maps untuk meningkatkan visibilitas dan menarik lebih banyak pelanggan lokal.',
      icon: <MapPin size={32} />
    },
    {
      title: 'Solusi Digital Sederhana dan Efektif',
      description: 'Menyediakan solusi digital yang mudah digunakan, efektif, dan benar-benar membantu perkembangan bisnis tanpa kompleksitas yang tidak perlu.',
      icon: <Wrench size={32} />
    },
    {
      title: 'Maintenance & Dukungan Website',
      description: 'Memberikan layanan maintenance dan dukungan teknis berkelanjutan untuk memastikan website selalu optimal dan terupdate.',
      icon: <Users size={32} />
    },
    {
      title: 'Dirancang untuk UMKM Indonesia',
      description: 'Solusi yang dipahami secara mendalam untuk kebutuhan spesifik UMKM dan bisnis lokal di Indonesia dengan harga yang terjangkau.',
      icon: <Globe size={32} />
    }
  ];

  return (
    <>
      {/* Hero Section */}
      <section className="about-hero">
        <div className="about-hero__inner">
          <div className="about-hero__content">
            <span className="about-hero__badge">🏢 Tentang PT CAKRA DIGITAL INNOVATION</span>
            <h1 className="about-hero__title">
              <span className="about-hero__title-main">Solusi Digital</span>
              <span className="about-hero__title-accent">untuk Pertumbuhan Bisnis</span>
            </h1>
            <p className="about-hero__subtitle">
              Perusahaan digital resmi yang berkomitmen membantu UMKM dan bisnis lokal membangun sistem digital yang profesional dan menghasilkan pertumbuhan nyata.
            </p>
            <div className="about-hero__stats">
              <div className="about-hero__stat">
                <div className="about-hero__stat-number">{operatingMonths}</div>
                <div className="about-hero__stat-label">Bulan Berjalan</div>
              </div>
              <div className="about-hero__stat">
                <div className="about-hero__stat-number">100%</div>
                <div className="about-hero__stat-label">Klien Puas</div>
              </div>
              <div className="about-hero__stat">
                <div className="about-hero__stat-number">2</div>
                <div className="about-hero__stat-label">Tim Digital</div>
              </div>
            </div>
            <div className="about-hero__trust">
              <div className="trust-badges">
                <div className="trust-badge">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                  </svg>
                  <span>NIB Resmi 2005260092859</span>
                </div>
                <div className="trust-badge">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M12 15a3 3 0 100-6 3 3 0 000 6z"/>
                    <path d="M12 7v3m0 0v.01M12 21a9 9 0 110-18 0 9 9 0 010 18z"/>
                  </svg>
                  <span>PT Berbadan Hukum</span>
                </div>
                <div className="trust-badge">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                  </svg>
                  <span>Risiko Rendah</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Story Section */}
      <section className="about-story">
        <div className="about-story__inner">
          <div className="about-story__grid">
            <div className="about-story__content">
              <div className="section-header">
                <h2 className="section-title">Our Story</h2>
                <p className="section-subtitle">Dari filosofi yang kuat, menuju perusahaan transformasi digital yang berdampak</p>
              </div>
              <div className="about-story__text">
                <p className="about-story__paragraph">
                  PT Cakra Digital Innovation lahir dari keyakinan mendalam bahwa teknologi harus mampu memberikan dampak nyata bagi pertumbuhan bisnis. Kami tidak dimulai dengan ambisi untuk menjadi perusahaan besar, melainkan dari keinginan tulus untuk membantu UMKM, startup, dan bisnis yang sedang berkembang membangun fondasi digital yang kuat dan relevan.
                </p>
                <p className="about-story__paragraph">
                  Nama kami bukan sekadar label, melainkan cerminan dari filosofi yang menggerakkan setiap langkah kami. <strong>Cakra</strong> melambangkan akar budaya dan kontinuitas yang kuat, sementara <strong>Digital Innovation</strong> mewakili komitmen kami untuk terus mencari cara baru yang lebih baik. Bagi kami, teknologi bukan sekadar alat, melainkan fondasi untuk membantu organisasi bekerja lebih efisien, berinovasi lebih cepat, mengambil keputusan yang lebih baik, dan tumbuh secara berkelanjutan.
                </p>
                <p className="about-story__paragraph">
                  <strong>Makna di balik nama kami</strong>
                </p>
                <p className="about-story__paragraph">
                  <strong>Cakra</strong><br />
                  Roda · Aksara Jawa “Ra”<br />
                  Simbol roda kehidupan yang terus berputar, berakar pada budaya, dan menjadi pijakan untuk bergerak maju dengan arah yang jelas. Seperti cakra yang tidak pernah berhenti, kami terus bergerak maju, berinovasi, dan berkembang bersama mitra kami.
                </p>
                <p className="about-story__paragraph">
                  <strong>Digital</strong><br />
                  Teknologi · Internet · Platform<br />
                  Melalui teknologi, internet, dan platform digital, kami membantu organisasi menciptakan, mengelola, dan memperluas dampak mereka dengan cara yang lebih efektif, scalable, dan berkelanjutan.
                </p>
                <p className="about-story__paragraph">
                  <strong>Innovation</strong><br />
                  Ide baru · Nilai tambah · Perubahan<br />
                  Inovasi bagi kami adalah proses berkelanjutan menciptakan nilai tambah, memperbaiki pengalaman, dan membuka peluang pertumbuhan yang sebelumnya belum terjangkau. Kami percaya bahwa inovasi bukan tentang teknologi itu sendiri, melainkan tentang dampak yang diciptakan.
                </p>
                <p className="about-story__paragraph">
                  <strong>Misi kami</strong><br />
                  Menjadi mitra transformasi digital yang membantu organisasi dari berbagai skala mempercepat inovasi, meningkatkan efisiensi operasional, dan mencapai pertumbuhan berkelanjutan melalui solusi teknologi yang inovatif, aman, dan terukur.
                </p>
                <p className="about-story__paragraph">
                  <strong>November 2025</strong><br />
                  Bermula dari satu orang, satu keyakinan<br />
                  Perjalanan kami dimulai dengan fokus mendalam pada pemahaman kebutuhan bisnis lokal. Setiap proyek dikerjakan dengan komitmen penuh untuk membangun fondasi kepercayaan dan pemahaman yang mendalam tentang tantangan dan peluang yang dihadapi oleh UMKM dan bisnis yang sedang berkembang.
                </p>
                <p className="about-story__paragraph">
                  <strong>15 Februari 2026</strong><br />
                  Bertemu rekan, mulai membangun visi bersama<br />
                  Saat perjalanan solo berkembang menjadi kolaborasi, hadir rekan kerja yang berbagi visi yang sama. Pada titik ini, kami mulai membangun perusahaan secara lebih terstruktur dengan legalitas resmi sebagai fondasi, dan komitmen kolektif untuk memberikan dampak yang lebih luas.
                </p>
                <p className="about-story__paragraph">
                  <strong>NIB: 1502260008495 · KBLI 62090 · PT</strong>
                </p>
                <p className="about-story__paragraph">
                  <strong>20 Mei 2026</strong><br />
                  PT Cakra Digital Innovation resmi berdiri<br />
                  Langkah ini menandai transformasi dari inisiatif pribadi menjadi institusi yang siap melayani lebih banyak organisasi dengan tanggung jawab yang lebih besar. Kami melangkah dengan keyakinan bahwa kepercayaan dibangun melalui konsistensi, kualitas, dan dampak yang nyata.
                </p>
                <p className="about-story__paragraph">
                  <strong>NIB: 2005260092859 · PMDN · PT</strong>
                </p>
                <p className="about-story__paragraph">
                  <strong>Perjalanan kami berlanjut</strong><br />
                  Seiring berkembangnya kepercayaan dan pemahaman kami, CDI terus berkembang untuk menghadirkan solusi yang lebih komprehensif. Dari membantu UMKM membangun kehadiran digital, kami kini juga menjadi mitra transformasi digital yang menghadirkan solusi berbasis AI, Cloud Computing, Software Engineering, Managed IT Services, Business Automation, Cyber Security, Enterprise Solutions, dan Digital Consulting.
                </p>
                <p className="about-story__paragraph">
                  “Kami percaya bahwa transformasi digital bukan tentang ukuran perusahaan, melainkan tentang komitmen untuk menciptakan dampak nyata. Seperti roda cakra yang terus berputar, kami bergerak bersama Anda—dari UMKM hingga enterprise—menuju masa depan di mana teknologi menjadi fondasi untuk pertumbuhan yang berkelanjutan dan inovasi yang tak terbatas.”
                </p>
                <p className="about-story__paragraph">
                  <strong>Tim Cakra Digital Innovation</strong>
                </p>
              </div>
            </div>
            <div className="about-story__visual">
              <div className="about-story__image">
                <img 
                  src={`${process.env.PUBLIC_URL}/cakra_digital_innovation.png`}
                  alt="PT CAKRA DIGITAL INNOVATION Team"
                  className="about-story__img"
                  loading="lazy"
                  decoding="async"
                />
                <div className="about-story__overlay">
                  <div className="about-story__overlay-content">
                    <h3>Digital Innovation Since 2026</h3>
                    <p>Mitra Transformasi Digital untuk Pertumbuhan Berkelanjutan</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Komitmen Kami Section */}
      <section className="about-commitment">
        <div className="about-commitment__inner">
          <div className="section-header">
            <div className="section-badge">Komitmen Kami</div>
            <h2 className="section-title">Dedikasi untuk Transformasi Digital Indonesia</h2>
            <p className="section-subtitle">
              PT CAKRA DIGITAL INNOVATION berkomitmen menjadi mitra transformasi digital bagi UMKM, perusahaan, organisasi, dan institusi di Indonesia melalui solusi teknologi berbasis AI, Cloud, Software Engineering, Managed IT Services, Cyber Security, Business Automation, dan pengembangan aplikasi yang inovatif, aman, serta berkelanjutan.
            </p>
            <p className="section-subtitle">
              Kami percaya bahwa teknologi bukan hanya alat, tetapi fondasi untuk meningkatkan efisiensi operasional, mempercepat inovasi, memperkuat daya saing, dan menciptakan pertumbuhan bisnis yang berkelanjutan di era digital.
            </p>
          </div>
          
          <div className="commitment-grid">
            {commitments.map((commitment, index) => (
              <div key={index} className="commitment-card">
                <div className={`commitment-card__icon-wrapper commitment-card__icon-wrapper--${index}`}>
                  <div className="commitment-card__icon">
                    {commitment.icon}
                  </div>
                </div>
                <div className="commitment-card__content">
                  <h3 className={`commitment-card__title ${commitment.specialTitle ? 'special-title' : ''}`}>{commitment.title}</h3>
                  <p className="commitment-card__description">{commitment.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="about-team">
        <div className="about-team__inner">
          <div className="section-header">
            <h2 className="section-title">Tim Digital Kami</h2>
            <p className="section-subtitle">Profesional berkomitmen untuk kesuksesan digital bisnis Anda</p>
          </div>
          <div className="team-grid">
            {teamMembers.map((member, index) => (
              <div key={index} className="team-card">
                <div className="team-card__profile">
                  <div className="team-card__image-wrapper">
                    <img 
                      src={member.image}
                      alt={member.name}
                      className="team-card__img"
                      loading="lazy"
                      decoding="async"
                    />
                    <div className="team-card__badge">
                      <span className="team-card__badge-text">{member.role.includes('Founder') ? 'Founder' : 'Specialist'}</span>
                    </div>
                  </div>
                  <div className="team-card__info">
                    <h3 className="team-card__name">{member.name}</h3>
                    <p className="team-card__role">{member.role}</p>
                  </div>
                </div>
                
                <div className="team-card__details">
                  <p className="team-card__bio">{member.bio}</p>
                  
                  <div className="team-card__skills">
                    <h4>Keahlian</h4>
                    <div className="team-card__expertise">
                      {member.expertise.map((skill, skillIndex) => (
                        <span key={skillIndex} className="team-card__skill">{skill}</span>
                      ))}
                    </div>
                  </div>
                  
                  <div className="team-card__stats">
                    <div className="team-card__stat">
                      <span className="team-card__stat-number">{member.stats.years}</span>
                      <span className="team-card__stat-label">Tahun</span>
                    </div>
                    <div className="team-card__stat">
                      <span className="team-card__stat-number">{member.stats.satisfaction}</span>
                      <span className="team-card__stat-label">Puas</span>
                    </div>
                    <div className="team-card__stat">
                      <span className="team-card__stat-number">{member.stats.services}</span>
                      <span className="team-card__stat-label">Layanan</span>
                    </div>
                  </div>
                  
                  <div className="team-card__contact">
                    <div className="team-card__contact-info">
                      <div className="team-card__contact-item">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                        </svg>
                        <span>Tersedia untuk Konsultasi</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Current Growth Stage Section */}
      <section className="about-growth">
        <div className="about-growth__inner">
          <div className="section-header">
            <h2 className="section-title">Fase Pertumbuhan Saat Ini</h2>
            <p className="section-subtitle">Membangun fondasi kuat untuk masa depan yang cerah</p>
          </div>
          <div className="growth-content">
            <div className="growth-text">
              <p className="growth-paragraph">
                <strong>Kami berada di fase pertumbuhan awal yang penuh potensi.</strong> Sebagai perusahaan berbadan hukum PT yang baru resmi terdaftar, kami sedang membangun fondasi yang kokoh untuk pertumbuhan jangka panjang. Fase ini adalah kekuatan kami, bukan kelemahan — setiap langkah dilakukan dengan perencanaan matang dan komitmen penuh.
              </p>
              <p className="growth-paragraph">
                <strong>Saat ini kami memiliki 1 klien aktif dengan tingkat kepuasan yang sangat baik.</strong> Fokus kami bukan pada jumlah klien, melainkan pada kualitas layanan dan hasil yang nyata. Setiap proyek menjadi portfolio dan bukti komitmen kami terhadap kepuasan klien.
              </p>
              <p className="growth-paragraph">
                <strong>Setiap proyek ditangani langsung oleh founder.</strong> Ini memastikan kualitas konsisten, komunikasi yang efektif, dan pemahaman mendalam tentang kebutuhan klien. Tidak ada delegasi ke pihak ketiga — hanya fokus pada hasil terbaik.
              </p>
            </div>
            <div className="growth-stats">
              <div className="growth-stat">
                <div className="growth-stat__icon">🌱</div>
                <h4>Fase Awal</h4>
                <p>Membangun fondasi kuat untuk pertumbuhan berkelanjutan</p>
              </div>
              <div className="growth-stat">
                <div className="growth-stat__icon">🎯</div>
                <h4>Fokus Kualitas</h4>
                <p>Kepuasan klien menjadi prioritas utama di setiap proyek</p>
              </div>
              <div className="growth-stat">
                <div className="growth-stat__icon">📈</div>
                <h4>Potensi Besar</h4>
                <p>Siap berkembang bersama mitra bisnis yang tepat</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Vision, Mission, Moto, Slogan Section */}
      <section className="about-vision-mission">
        <div className="about-vision-mission__inner">
          <div className="section-header">
            <h2 className="section-title">Visi, Misi, & Moto</h2>
            <p className="section-subtitle">Panduan kami dalam membangun mitra digital terpercaya</p>
          </div>
          
          <div className="vision-mission-grid">
            <div className="vision-card">
              <div className="vision-card__icon">👁️</div>
              <h3 className="vision-card__title">Visi</h3>
              <p className="vision-card__description">
                Menjadi perusahaan transformasi digital terdepan di Indonesia yang menghadirkan solusi berbasis AI, Cloud, Software Engineering, 
                <br />
                dan Managed IT Services untuk membantu organisasi bertumbuh secara berkelanjutan di era digital.
              </p>
            </div>
            
            <div className="mission-card">
              <div className="mission-card__icon">🎯</div>
              <h3 className="mission-card__title">Misi</h3>
              <ul className="mission-list">
                <li>Mengembangkan solusi teknologi yang inovatif, aman, dan skalabel sesuai kebutuhan bisnis.</li>
                <li>Membantu organisasi mempercepat transformasi digital melalui AI, Cloud, Automation, dan Enterprise Software.</li>
                <li>Menyediakan layanan Managed IT Services yang andal untuk memastikan keberlangsungan operasional pelanggan.</li>
                <li>Mendorong pengambilan keputusan berbasis data melalui Business Intelligence dan Data Analytics.</li>
                <li>Membangun kemitraan jangka panjang yang berlandaskan integritas, kolaborasi, dan inovasi berkelanjutan.</li>
                <li>Terus mengembangkan talenta dan budaya inovasi untuk menghadapi perubahan teknologi global.</li>
                <li>Membangun hubungan jangka panjang yang jujur dan transparan</li>
              </ul>
            </div>
          </div>
          
          <div className="moto-slogan-section">
            <div className="moto-card">
              <div className="moto-card__icon">🧠</div>
              <h3 className="moto-card__title">Moto</h3>
              <p className="moto-card__text">
                Engineering Digital Transformation
              </p>
            </div>
            
            <div className="slogan-card">
              <div className="slogan-card__icon">🚀</div>
              <h3 className="slogan-card__title">Slogan</h3>
              <p className="slogan-card__text">
                Accelerating Digital Transformation for a Better Future
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="about-values">
        <div className="about-values__inner">
          <div className="section-header">
            <h2 className="section-title">Nilai-Nilai Kami</h2>
            <p className="section-subtitle">Prinsip yang memandu setiap keputusan kami</p>
          </div>
          <div className="values-grid">
            <div className="value-card">
              <div className="value-card__icon">🎯</div>
              <h3 className="value-card__title">Hasil Terukur</h3>
              <p className="value-card__description">
                Kami mengukur kesuksesan dari kesuksesan Anda. Setiap solusi yang kami buat dirancang untuk menghasilkan 
                pertumbuhan bisnis yang nyata dan ROI yang terukur bagi klien.
              </p>
              <div className="value-card__metrics">
                <div className="value-card__metric">
                  <span className="value-card__metric-number">Fokus</span>
                  <span className="value-card__metric-label">Pertumbuhan Klien</span>
                </div>
              </div>
            </div>
            <div className="value-card">
              <div className="value-card__icon">🚀</div>
              <h3 className="value-card__title">Inovasi Berkelanjutan</h3>
              <p className="value-card__description">
                Kami terus belajar dan mengikuti tren digital terkini untuk memastikan klien selalu mendapatkan 
                solusi yang memberikan keunggulan kompetitif.
              </p>
              <div className="value-card__metrics">
                <div className="value-card__metric">
                  <span className="value-card__metric-number">Update</span>
                  <span className="value-card__metric-label">Terus Menerus</span>
                </div>
              </div>
            </div>
            <div className="value-card">
              <div className="value-card__icon">🤝</div>
              <h3 className="value-card__title">Partnership Jangka Panjang</h3>
              <p className="value-card__description">
                Kami tidak hanya membangun proyek; kami membangun hubungan lasting. Kesuksesan kami terikat 
                dengan kesuksesan Anda, dan kami berkomitmen menjadi mitra digital jangka panjang.
              </p>
              <div className="value-card__metrics">
                <div className="value-card__metric">
                  <span className="value-card__metric-number">100%</span>
                  <span className="value-card__metric-label">Komitmen</span>
                </div>
              </div>
            </div>
            <div className="value-card">
              <div className="value-card__icon">💡</div>
              <h3 className="value-card__title">Simplicity & Kualitas</h3>
              <p className="value-card__description">
                Masalah kompleks membutuhkan solusi yang elegan. Kami mengubah tantangan teknis 
                menjadi pengalaman yang intuitif dan user-friendly.
              </p>
              <div className="value-card__metrics">
                <div className="value-card__metric">
                  <span className="value-card__metric-number">Standar</span>
                  <span className="value-card__metric-label">Tinggi</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Testimonials Section */}
      <section className="about-testimonials">
        <div className="about-testimonials__inner">
          <div className="section-header">
            <h2 className="section-title">Apa Kata Mereka</h2>
            <p className="section-subtitle">Mereka percaya pada kami</p>
          </div>
          <div className="testimonials-grid">
            {/* Testimonial cards would go here */}
          </div>
        </div>
      </section>
      {/* Case Studies Section */}
      <section className="about-case-studies">
        <div className="about-case-studies__inner">
          <div className="section-header">
            <h2 className="section-title">Studi Kasus</h2>
            <p className="section-subtitle">Pengalaman sukses dalam memberikan solusi digital</p>
          </div>
          <div className="case-studies-grid">
            {/* Case study cards would go here */}
          </div>
        </div>
      </section>
      {/* Newsletter Section */}
      <section className="about-newsletter">
        <div className="about-newsletter__inner">
          <div className="section-header">
            <h2 className="section-title">Berlangganan Newsletter</h2>
            <p className="section-subtitle">Dapatkan update terbaru dan tips digital marketing</p>
          </div>
          <div className="newsletter-form">
            {/* Newsletter form would go here */}
          </div>
        </div>
      </section>
      {/* Expertise Section */}
      <section className="about-expertise">
        <div className="about-expertise__inner">
          <div className="section-header">
            <h2 className="section-title">Keahlian Kami</h2>
            <p className="section-subtitle">Solusi digital fokus untuk hasil maksimal</p>
          </div>
          <div className="expertise-grid">
            <div className="expertise-card">
              <div className="expertise-card__icon">🌐</div>
              <h3 className="expertise-card__title">Website Development</h3>
              <p className="expertise-card__description">
                Website profesional yang modern, responsif, dan dioptimasi untuk konversi dengan teknologi terkini.
              </p>
              <div className="expertise-card__features">
                <span className="expertise-card__feature">Website Bisnis</span>
                <span className="expertise-card__feature">E-commerce</span>
                <span className="expertise-card__feature">Website Custom</span>
              </div>
              <div className="expertise-card__stats">
                <div className="expertise-card__stat">
                  <span className="expertise-card__stat-number">Fokus</span>
                  <span className="expertise-card__stat-label">Utama</span>
                </div>
              </div>
            </div>
            <div className="expertise-card">
              <div className="expertise-card__icon">�</div>
              <h3 className="expertise-card__title">SEO Optimization</h3>
              <p className="expertise-card__description">
                Optimasi mesin pencari untuk meningkatkan visibilitas bisnis dan mendatangkan traffic berkualitas.
              </p>
              <div className="expertise-card__features">
                <span className="expertise-card__feature">SEO On-Page</span>
                <span className="expertise-card__feature">Local SEO</span>
                <span className="expertise-card__feature">Analytics</span>
              </div>
              <div className="expertise-card__stats">
                <div className="expertise-card__stat">
                  <span className="expertise-card__stat-number">Fokus</span>
                  <span className="expertise-card__stat-label">Utama</span>
                </div>
              </div>
            </div>
            <div className="expertise-card">
              <div className="expertise-card__icon">�</div>
              <h3 className="expertise-card__title">Digital Marketing</h3>
              <p className="expertise-card__description">
                Strategi pemasaran digital terukur untuk meningkatkan brand awareness dan generate leads berkualitas.
              </p>
              <div className="expertise-card__features">
                <span className="expertise-card__feature">Social Media</span>
                <span className="expertise-card__feature">Content Marketing</span>
                <span className="expertise-card__feature">PPC Ads</span>
              </div>
              <div className="expertise-card__stats">
                <div className="expertise-card__stat">
                  <span className="expertise-card__stat-number">Fokus</span>
                  <span className="expertise-card__stat-label">Utama</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Future Direction Section */}
      <section className="about-future">
        <div className="about-future__inner">
          <div className="section-header">
            <h2 className="section-title">Arah Masa Depan</h2>
            <p className="section-subtitle">Visi jangka panjang yang realistis dan terukur</p>
          </div>
          
          <div className="future-content">
            <div className="future-text">
              <p className="future-paragraph">
                <strong>Tahun 1-2: Fondasi & Portfolio</strong><br/>
                Membangun fondasi perusahaan yang kuat melalui kolaborasi dengan UMKM, startup, dan bisnis lokal. 
                <br/>Fokus pada pengembangan portofolio berkualitas, penyempurnaan standar operasional, 
                <br/>serta membangun reputasi sebagai mitra digital yang profesional dan terpercaya.
              </p>
              <p className="future-paragraph">
                <strong>Tahun 3-5: Ekspansi Terukur</strong><br/>
                Memperluas layanan ke perusahaan skala menengah di wilayah Jabodetabek, memperkuat tim profesional,
                <br /> serta menghadirkan solusi berbasis AI, Cloud, 
                <br/> dan Business Automation untuk menjawab kebutuhan transformasi digital yang terus berkembang.
              </p>
              <p className="future-paragraph">
                <strong>Tahun 6-10: Pionir Digital</strong><br/>
                Menjadi pionir digital di Indonesia dengan portfolio 100+ klien puas dan tim yang solid.
              </p>
              <p className="future-paragraph">
                <strong>Tahun 5+: Pertumbuhan Berkelanjutan</strong><br/>
                Berkembang menjadi perusahaan Technology Solutions & Digital Transformation yang melayani UMKM, perusahaan menengah,
                <br /> hingga organisasi dan institusi melalui solusi teknologi yang inovatif, aman, dan berkelanjutan.
              </p>
            </div>
            <div className="future-commitment">
              <div className="commitment-card">
                <h4>Komitmen Kami</h4>
                <p>Kami percaya bahwa pertumbuhan yang berkelanjutan dibangun melalui kualitas, integritas, dan kepercayaan. Oleh karena itu, kami berkomitmen untuk memberikan solusi teknologi terbaik bagi setiap pelanggan, mulai dari UMKM hingga organisasi yang sedang berkembang, tanpa mengorbankan kualitas layanan demi pertumbuhan yang cepat.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="about-cta">
        <div className="about-cta__inner">
          <div className="about-cta__content">
            <h2 className="about-cta__title">Siap Membangun Website untuk Meningkatkan Omset?</h2>
            <p className="about-cta__subtitle">
              Mari diskusikan bagaimana kami dapat membantu bisnis Anda berkembang dengan solusi digital yang tepat dan terukur.
            </p>
            <div className="about-cta__buttons">
              <Link to="/consultation" className="btn btn-primary btn-large">
                <span className="btn__icon">💬</span>
                <span>Mulai Perjalanan Digital Anda</span>
              </Link>
              <Link to="/portfolio" className="btn btn-secondary btn-large">
                <span className="btn__icon">🎨</span>
                <span>Lihat Portfolio Kami</span>
              </Link>
            </div>
            <div className="about-cta__stats">
              <div className="about-cta__stat">
                <div className="about-cta__stat-number">100%</div>
                <div className="about-cta__stat-label">Klien Puas</div>
              </div>
              <div className="about-cta__stat">
                <div className="about-cta__stat-number">1+</div>
                <div className="about-cta__stat-label">Tahun Pengalaman</div>
              </div>
              <div className="about-cta__stat">
                <div className="about-cta__stat-number">3</div>
                <div className="about-cta__stat-label">Layanan Fokus</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Tentang;
